import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, Observable, of, switchMap } from 'rxjs';
import { Action } from '@ngrx/store';
import { GoogleTagManagerService } from '@cp/shared/google-tag-manager/google-tag-manager.service';
import { AdvancePreferencesActions } from '../actions/advance-preferences.actions';
import { NmcNmbiStatusActions } from '../actions/nmc-nmbi-status.actions';
import {
  StaffDetailsActions,
  StaffDetailsAPIActions,
} from '../actions/staff-details.actions';
import { ProfileHttpService } from '../../http/profile/profile-http.service';

@Injectable()
export class StaffDetailsEffects {
  public loadStaffDetails$: Observable<Action> = createEffect(() =>
    this._actions$.pipe(
      ofType(StaffDetailsActions.loadStaffDetails),
      switchMap(() =>
        this._profileHttpService.staffDetails$.pipe(
          mergeMap((staffDetails) =>
            of(
              StaffDetailsAPIActions.loadedStaffDetailsSuccessfully({
                staffDetails,
              }),
            ),
          ),
          catchError((error) =>
            of(
              StaffDetailsAPIActions.loadedStaffDetailsUnsuccessfully({
                error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public pushStaffNumberOnDataLayer$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(StaffDetailsAPIActions.loadedStaffDetailsSuccessfully),
        mergeMap(({ staffDetails: { staffNumber } }) =>
          this._gtmService.pushTag({ user_id: staffNumber }),
        ),
      ),
    { dispatch: false },
  );

  public loadNMCNMBIAfterStaffDetails$ = createEffect(() =>
    this._actions$.pipe(
      ofType(StaffDetailsAPIActions.loadedStaffDetailsSuccessfully),
      mergeMap(() => of(NmcNmbiStatusActions.loadNMCNMBIStatus())),
    ),
  );

  public loadAdvancePreferencesAfterStaffDetails$ = createEffect(() =>
    this._actions$.pipe(
      ofType(StaffDetailsAPIActions.loadedStaffDetailsSuccessfully),
      mergeMap(() => of(AdvancePreferencesActions.loadAdvancePreferences())),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _profileHttpService: ProfileHttpService,
    private _gtmService: GoogleTagManagerService,
  ) {}
}
